module.exports = __webpack_public_path__ + "static/media/YM84_2.36482353.jpg";